var DependencyFilter = function () {
    function recursive(obj, newObj, level, itemName, isExpand) {
        for (var key in obj) {
            var o = obj[key];
            o.name = key;
        }

        angular.forEach(obj, function (o) {
            if (o.dependencies) {
                o.level = level;
                o.leaf = false;
                newObj.push(o);

                if (o.name == itemName) {
                    o.expand = isExpand;
                }
                if (o.expand == true) {
                    recursive(o.dependencies, newObj, o.level + 1, itemName, isExpand);
                }
            } else {
                o.level = level;
                o.leaf = true;
                newObj.push(o);
                return false;
            }
        }); //End of for each
    }

    return function (parentObj, itemName, isExpand) {
        var newObj = [];
        var level = 0;
        recursive(parentObj, newObj, level, itemName, isExpand);
        return newObj;
    };
};

export default DependencyFilter;
